export enum PrefillPrompts {
	MarketingCampaignPrompt = 'marketingCampaignPrompt',
	ProsAndConsPrompt = 'prosAndConsPrompt',
	CompetitiveAnalysisPrompt = 'competitiveAnalysisPrompt',
	DocumentationPrompt = 'documentationPrompt',
	OnboardingGuidePrompt = 'onboardingGuidePrompt',
	SprintPlanningPrompt = 'sprintPlanningPrompt',
	BudgetPlanPrompt = 'budgetPlanPrompt',
}
